import * as type from './types'

export function fetchDownloadReports(data) {
    return {
        type: type.FETCH_DOWNLOAD_REPORTS,
        payload: data
    };
}

export function fetchedDownloadReports() {
    return {
        type: type.FETCHED_DOWNLOAD_REPORTS,
    };
}

export function fetchDownloadDataWcWi(data) {
    return {
        type: type.FETCH_DOWNLOAD_DATA_WC_WI,
        payload: data
    };
}

export function fetchedDownloadDataWcWi(data) {
    return {
        type: type.FETCHED_DOWNLOAD_DATA_WC_WI,
        payload: data
    };
}

export function fetchDownloadReconciliation(data, xlResponse) {
    return {
        type: type.FETCH_DOWNLOAD_RECONCILIATION,
        payload: data,
        payload1: xlResponse
    }
}

export function fetchedDownloadReconciliation(data) {
    return {
        type: type.FETCHED_DOWNLOAD_RECONCILIATION,
        payload: data
    };
}

export function fetchDownloadDmsToRlbPost(data) {
    return {
        type: type.FETCH_DOWNLOAD_DMS_TO_RLB_POST,
        payload: data
    };
}

export function fetchedDownloadDmsToRlbPost(data) {
    return {
        type: type.FETCHED_DOWNLOAD_DMS_TO_RLB_POST,
        payload: data
    };
}


